import { IReportingPeriodApplicantDocument } from "../../model/document/ReportingPeriodApplicantDocument";
import { IReportingPeriodApplicantDocumentService } from "../../service/document/ReportingPeriodApplicantDocumentService";

export default class AssignReportingPeriodApplicantDocumentInteractor {
  private reportingPeriodApplicantDocumentService: IReportingPeriodApplicantDocumentService;

  constructor(reportingPeriodApplicantDocumentService) {
    this.reportingPeriodApplicantDocumentService = reportingPeriodApplicantDocumentService;
  }

  async execute(
    reportingPeriodApplicantDocument: IReportingPeriodApplicantDocument
  ) {
    await this.reportingPeriodApplicantDocumentService.assignReportingPeriodApplicantDocument(
      reportingPeriodApplicantDocument
    );
  }
}
